import { Component } from "preact";
import '../style/start-form.css';
import { ConfigContext } from '../contexts/config';

export default class ResumeMismatchForm extends Component {
    handleStartNew(e) {
        e.preventDefault()

        this.props.onDecision(0)
    }

    handleKeepOld(e) {
        e.preventDefault()

        this.props.onDecision(1)
    }

    render() {
        return (
            <ConfigContext.Consumer>
                {config => (
                    <div className={'resume-mismatch'}>
                        {config.getTranslations().resumeMismatchMessage !== null &&
                            <p>{config.getTranslations().resumeMismatchMessage}</p>
                        }
                        <button
                            className={'abort'}
                            onClick={this.handleStartNew.bind(this)}
                        >
                            {config.getTranslations().resumeMismatchStartNewLabel}
                        </button>
                        <button
                            className={'resume'}
                            onClick={this.handleKeepOld.bind(this)}
                        >
                            {config.getTranslations().resumeMismatchKeepOldLabel}
                        </button>
                    </div>
                )}
            </ConfigContext.Consumer>
        )
    }
}